import {isEmptyArray} from "./is-empty-array";

export const isEmptyObject = (object) => isEmptyArray(Object.keys(object));
